export default __webpack_public_path__ + "static/media/AXIA_White_logo.3f1a485a.png";